import React from 'react';
import {
  AccountRawData,
  ContractDataRawResult,
  GetDeployResult,
  NFTTokenMetadataEntry,
  URefRawData,
} from '@block-explorer/entities';
import { AccountInfoAccordion } from '../account-info-accordion/account-info-accordion';
import { RawDetails } from '../raw-details/raw-details';
import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';
import { GetBlockResult, StoredValue } from 'casper-js-sdk';

interface DetailsAccordionAccountRawDataProps {
  accordionTitle: React.ReactElement;
  data:
    | GetBlockResult
    | AccountRawData
    | GetDeployResult
    | URefRawData
    | ContractDataRawResult
    | StoredValue
    | NFTTokenMetadataEntry[]
    | undefined
    | null;
  loading: boolean;
}

const RawDetailsContainer = styled(FlexRow)(({ theme }) => ({
  padding: '24px 20px',
}));

export const DetailsAccordionAccountRawData = ({
  accordionTitle,
  data,
  loading,
}: DetailsAccordionAccountRawDataProps) => {
  return (
    <AccountInfoAccordion
      disableClickAway
      renderContent={() => (
        <RawDetailsContainer>
          <RawDetails loading={loading} data={data} withPageTile={false} />
        </RawDetailsContainer>
      )}
    >
      {accordionTitle}
    </AccountInfoAccordion>
  );
};
